import type MeetingTypeDescription from '../store/schema/MeetingTypeDescription';
import { getThemeImageEnumValue } from 'bookwithme-shared';

export function composeMeetingTypeDescription(
    descriptionString: string,
    themeImageString: string,
    emojiCode: string,
    privacyType: number,
    isAuthRequired: number,
    origin: string
): string {
    const themeImageId = getThemeImageEnumValue(themeImageString);
    // Create the new description schema, with version 1, will allow getting all MT properties from the MeetingTypeExtension.
    // will be really effective, using MeetingTypeExtension properties, when substrate OpenBookFilterPrivateMeetingTypes is enabled,
    // therefore filtering private BookingServices from pageDataPayload services, until then works the same as legacy using the service properties from payload.
    const version: number = 1;

    const meetingDescription: MeetingTypeDescription = {
        description: descriptionString,
        themeId: themeImageId,
        emojiCode,
        privacyType,
        isAuthRequired /*TO BE REMOVED*/,
        version,
        origin,
    };
    const returnDescription = JSON.stringify(meetingDescription);
    return returnDescription;
}

export function parseMeetingTypeDescription(serviceDescription: string): MeetingTypeDescription {
    let parsedDescription: any = undefined;
    //TODO: check privacyType once every meeting type has a privacyType
    if (serviceDescription?.indexOf('description') > -1) {
        try {
            parsedDescription = JSON.parse(serviceDescription);
            return parsedDescription;
        } catch (error) {
            // TODO: log error
            return getDefaultParsedDescription(serviceDescription);
        }
    }
    return getDefaultParsedDescription(serviceDescription);
}

function getDefaultParsedDescription(serviceDescription: string): MeetingTypeDescription {
    return {
        description: serviceDescription,
    };
}
